module.exports = __webpack_public_path__ + "b848208d54665bc6972bd31ff814d7cf.svg";


//////////////////
// WEBPACK FOOTER
// ./directives/navbar/combined-shape.svg
// module id = 246
// module chunks = 0